import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { StaticHtmlService } from '@core/services/static-html.service';

@Component({
    selector: 'help-icon',
    templateUrl: 'help-icon.component.html',
    styleUrls: ['./help-icon.component.scss']
})

export class HelpIconComponent implements OnInit {

    title: string;
    openModal: boolean = false;
    infoModal: any = null;
    @Input() label?: string;
    @Input() show?: boolean = false;

    constructor(
        private staticHtmlService: StaticHtmlService,
        private router: Router,
        private messageService: MessageService,
        private translateService: TranslateService) 
    { 
        this.title = this.translateService.instant('HELP');
    }

    ngOnInit() { }

    onOpenModal() {
        const path = this.router.url.split('?')[0].split('-').join('_').slice(1).split('/').join('__');
        const langauge = JSON.parse(localStorage.getItem('language'));
        const auxLabel = (this.label) ? this.label : "main";
		this.staticHtmlService.getStaticHTML(`assets/help/${langauge}/${path}_${auxLabel}_${langauge}.html`, true)
		.subscribe( 
            res => {
                this.infoModal = res;
                this.openModal = true
            },
            error => {
                this.messageService.clear()
				this.messageService.add({
					severity: 'info',
					summary: this.translateService.instant('HELP NOT FOUND'),
					detail: this.translateService.instant('THE HELP COULD NOT BE FOUND')
				})
            }
        )
        
    }

    closeModal(event) {
        this.openModal = false;
    }
}